import { colors } from "../colors";

let velocitySlicePlotOptions = (theme) => ({
  chart: {
    type: "spline",
    backgroundColor: null,
    plotBackgroundImage: "",
    animation: false,
    plotBorderWidth: 0,
    marginRight: 80, // determine the distance between graph and color bar
  },
  credits: {
    enabled: false,
  },
  boost: {
    enabled: false, // enable animation
    useGPUTranslations: true,
  },
  tooltip: {
    backgroundColor: colors.chartToolTipBkg,
    borderWidth: 0,
    borderRadius: 4,
    shadow: false,
    style: {
      color: colors.chartAxisLabel,
    },
    // formatter: function () {
    //   return this.x.toFixed(1) + ", " + this.y.toFixed(decimalPoints) + " m/s";
    // },
  },
  title: {
    text: null,
    style: {
      color: colors.chartTitle,
    },
  },
  xAxis: {
    title: {
      text: "Time (s)",
      offset: -30,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
        "border-radius": "4px",
        padding: "5px",
        "background-color": colors.chartAxisBkg,
      },
    },
    labels: {
      format: "{value}",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: false,
    endOnTick: false,
    minRange: 0,
    maxPadding: 0,
    minPadding: 0,
    tickLength: 5,
    tickInterval: 0.5, // The interval of the tick marks in axis units
  },
  yAxis: {
    title: {
      text: "sws (m/s)",
      offset: -30,
      useHTML: true,
      style: {
        color: colors.chartAxisLabel,
        "border-radius": "4px",
        padding: "5px",
        "background-color": colors.chartAxisBkg,
      },
    },
    labels: {
      format: "{value}",
      style: {
        color: colors.chartAxisLabel,
      },
    },
    startOnTick: false,
    endOnTick: false,
    maxPadding: 0,
    minPadding: 0,
    lineWidth: 1, // y-axis line
    gridLineWidth: 0,
    minorGridLineWidth: 0,
    tickWidth: 1,
    tickInterval: 0.5, // The interval of the tick marks in axis units
  },
  colorAxis: {
    stops: [
      [0, colors.velocitySlicePlotColorStop1],
      [0.3, colors.velocitySlicePlotColorStop2],
      [0.5, colors.velocitySlicePlotColorStop3],
      [0.75, colors.velocitySlicePlotColorStop4],
      [0.875, colors.velocitySlicePlotColorStop5],
      [1, colors.velocitySlicePlotColorStop6],
    ],
    min: -10,
    max: 10,
    startOnTick: true,
    endOnTick: true,
    labels: {
      format: "{value}",
      x: 3, // distance between color bar and colorbar label
      style: {
        color: colors.chartAxisLabel,
      },
    },
  },
  legend: {
    layout: "vertical",
    verticalAlign: "top",
    align: "right",
    symbolHeight: 160, // height of the color bar
    symbolPadding: 10,
    y: -8,
    title: {
      text: "Velocity",
      style: {
        fontSize: "11px",
        fontWeight: "unset",
        color: colors.chartAxisLabel,
      },
    },
  },
  plotOptions: {
    series: {
      allowPointSelect: false,
      point: {
        events: {},
      },
      states: {
        select: {
          color: colors[theme].primary,
          borderColor: colors[theme].primary,
          enabled: false,
        },
      },
    },
  },
  series: [
    {
      name: "Peaks",
      type: "spline",
      data: [],
      borderWidth: 1,
      colorKey: false,
      color: colors[theme].primary,
      visible: true,
      zIndex: 5,
      tooltip: {
        headerFormat: undefined,
        pointFormat: "{point.x:%0.1f} {series.name}, {point.y:%0.1f} m/s",
        valueSuffix: " cm",
      },
    },
  ],
});

export { velocitySlicePlotOptions };
